<template>
  <TopCard v-if="posts" :method="setArtist" :post="posts[0]"/>
  <GridDisplay title="Recomendados para ti" :method="setArtist" :posts="posts"/>
</template>

<script>
import TopCard from '@/components/TopCard.vue';
import GridDisplay from '@/components/GridDisplay.vue'
export default {
  components:{TopCard, GridDisplay},
  name: 'ArtistasView',
  data(){
    return{
      posts: [],
    }
  },
  mounted(){
    if(localStorage.getItem('token')!== null){
      const url= this.baseUrl +'/user/me/recommendations/artists?access_token='+localStorage.getItem('token');
      fetch(url)
        .then(response=>response.json())
        .then(json=>this.posts = json.data);
    }
    else{
      const url= this.baseUrl + '/chart/0/artists'
      fetch(url)
        .then(response=>response.json())
        .then(json=>this.posts = json.data);
    } 
    
  },
  methods:{
    setArtist(a){
      if(typeof a !== 'undefined'){
        const tracklistUrl = a.tracklist.slice(22)
        fetch(this.baseUrl + tracklistUrl)
          .then(response=>response.json())
          .then(json=> localStorage.setItem('currentSong', JSON.stringify(json.data[0])));
      }    
    }
  }
}
</script>